module.exports = __webpack_public_path__ + "img/search_web.e0ac267f.svg";